<template>
  <aside class="sidebar-left">
    <CompaniesList />
  </aside>
</template>

<script>
import CompaniesList from '@/components/app/general/CompaniesList';

export default {
  data: () => {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
  components: { CompaniesList}
}
</script>

<style lang="scss" scoped>
  .sidebar-left {
    width: 320px;
    height: calc(100vh - 60px);
    float: left;
    padding: 0;
    box-sizing: border-box;
    border-right: 1px solid #4C4C4C;
    color: #A1A1A1;
    background-color: #393939;
  }
</style>